import { getItemFromCollection } from "directus/src/operations";

export async function fetchPullRequest(id) {
  try {
    const response = await getItemFromCollection("pull_requests", id);

    const data = {
      ...response,
      action: response.action || "",
    }

    return data;
  } catch (error) {
    console.log(error);
  }
}
